import styled from 'styled-components';
import { HeadingTwo, SmallText } from '../../typography';
import Button from '../../ui/button';
import { BP_MOBILE_MAX, BP_TABLET_MAX } from '../../../assets/styles/breakpoints';
import { LoginFormTextInputSC } from '../../login/login-form/login-form.styled';
import { COLOR_RED, COLOR_WHITE } from '../../../assets/styles/colors';

export const AutomaticSaleModalSC = styled.div`
  .wishmaker-modal {
    &-content {
      width: 900px !important;
      padding: 48px 40px !important;
    }
  }
`;

export const SaleTableItemSC = styled.tr`
  background: ${COLOR_WHITE};
  &:first-child {
    td {
      &:first-child {
        border-top-left-radius: 0px;
      }
      &:last-child {
        border-top-right-radius: 0px;
      }
    }
  }
  &:last-child {
    td {
      &:first-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-left-radius: 12px;`)}
      }
      &:last-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-right-radius: 12px;`)}
      }
      &:after {
        display: none;
      }
    }
  }
  &:hover {
    cursor: pointer;
    td {
      background: #f8f8f9;
    }
  }
  td {
    height: 60px;
    text-align: center;
    position: relative;
    max-width: 200px;
    padding: 0 8px;

    &:after {
      content: '';
      position: absolute;
      bottom: 0px;
      height: 1px;
      width: 100%;
      background: rgba(47, 46, 65, 0.1);
      left: 0;
    }
    &:first-child {
      padding-left: 22px;
      width: 50px;
      &:after {
        right: 0px;
        left: auto;
      }
    }
    &:last-child {
      padding-right: 22px;
      &:after {
        right: auto;
        left: 0px;
      }
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    td {
      text-align: left;
      &:first-child {
        padding-left: 8px;
        text-align: left;
      }
      &:last-child {
        padding-right: 8px;
        text-align: right;
        small:last-child {
          margin-left: 20px;
        }
      }
    }
  }
`;

export const StyledHeading = styled(HeadingTwo)`
  text-align: center;
`;

export const StyledDescription = styled(SmallText)`
  margin-top: 28px;

  color: #3f3d56;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  margin-top: 21px;
`;

export const SearchButton = styled(Button).attrs((props) => ({
  ...props,
  htmlType: 'button',
}))`
  /* flex: 1; */
  min-width: 183px;
  margin-left: 24px;
  height: 50px;

  @media (max-width: ${BP_MOBILE_MAX}px) {
    flex: unset;
    margin-left: 0;
    margin-top: 10px;
    width: 100%;
  }
`;

export const InputLabel = styled.label`
  margin-top: 28px;
  display: block;

  color: #3f3d56;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 15px;
`;

export const HeaderWrapper = styled.div`
  margin: 0 10px;
`;

export const InputRow = styled.div`
  display: flex;
  flex-wrap: wrap;

  align-items: flex-end;
  justify-content: center;
`;

export const InputWrapper = styled.div`
  @media (max-width: ${BP_MOBILE_MAX}px) {
    flex: unset;
    width: 100%;
  }
`;

export const StyledInput = styled(LoginFormTextInputSC)`
  width: 280px;
  height: 50px;

  @media (max-width: ${BP_MOBILE_MAX}px) {
    flex: unset;
    max-width: unset;
    width: 100%;
  }
`;

export const DetailTable = styled.table`
  width: 100%;
  thead {
    border-collapse: separate;
    tr {
      box-shadow: 0 1px 0 0 rgba(47, 46, 65, 0.1);
      th {
        font-weight: normal;
        text-align: center;
        padding-bottom: 8px;
        padding-top: 6px;
        background-color: #f8f8f9;
        box-shadow: 0 1px 0 0 rgba(47, 46, 65, 0.1);

        &:before {
          z-index: 0;
          position: absolute;
          top: 0px;
          left: 0px;
          content: '';
          width: 100%;
          height: 100%;
          border: 1px solid white;
          border-right: none;
          border-left: none;
        }

        &:first-child {
          border-top-left-radius: 10px;

          &:before {
            border-top-left-radius: 10px;
            border-left: 1px solid white;
          }
        }
        &:last-child {
          padding-right: 32px;
          border-top-tight-radius: 10px;
          &:before {
            border-top-tight-radius: 10px;
            border-right: 1px solid white;
          }
        }
      }
    }
    tbody {
      box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
      border-radius: 12px;
    }
    @media (max-width: ${BP_TABLET_MAX}px) {
      tbody {
        box-shadow: none;
        border-radius: 0px;
      }
    }
  }
`;

export const DetailTableWrapper = styled.div`
  margin: 26px 0;
  max-height: 300px;
  overflow-y: auto;
  border-radius: 10px;
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.1);

  @media only screen and (min-height: 1010px) {
    max-height: 430px;
  }
`;

export const ErrorText = styled(SmallText)`
  padding: 6px 0;
  text-align: center;
  width: 100%;
  color: ${COLOR_RED};
`;

export const SumWrapper = styled.div`
  text-align: center;
`;

export const SumLabel = styled.p`
  color: #3f3d56;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 15px;

  margin-bottom: 0;
`;

export const SumText = styled.div`
  color: #ff8e00;
  font-family: 'Source Sans Pro';
  font-size: 37px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 50px;
  text-align: center;
`;

export const TotalValueText = styled.span`
  color: #2f2e41;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  opacity: 0.5;
`;

export const NoContent = styled.div`
  opacity: 0.4;
  color: #3f3d56;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 15px;
  text-align: center;
  margin: 23px 0;
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  margin: 23px 0;
  display: flex;

  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const CheckboxWrapper = styled.div`
  .label {
    max-width: unset;
  }
  .label span {
    max-width: unset;
    font-size: 13px;
    line-height: 18px;
    /* font-weight: normal; */

    a {
      font-weight: bold;
    }
  }
`;

export const TableHead = styled.thead`
  th {
    position: sticky;
    top: 0;
    z-index: 999;
  }
`;
